export default __webpack_public_path__ + "static/media/loading.0f5b38df.svg";